export default function getDateStr (date = '00/00/0000', format) {
  const dateReceived = date?.slice(0, 10);
  const dateFormatted = format && dateReceived?.split('-').reverse().join('/');
  return dateFormatted || dateReceived
}
